import { Home, Users, Book, UploadCloud , Heart, Package, MessageCircle } from 'react-feather';
import { LuMonitorSmartphone } from 'react-icons/lu';
export const MENUITEMS = {
  admin: [
    {
      menutitle: "General",
      menucontent: "Dashboards, Widgets, Layouts",
      Items: [
        {
          title: "Home",
          icon: <Home />,
          path: `/dashboard`,
          type: "link",
          bookmark: true,
          active: false,
        },
      ]
    },
    {
      menutitle: "Management",
      menucontent: "Users, Sessions",
      Items: [
        {
          title: "Users",
          icon: <Users />,
          path: `/app/users`,
          type: "link",
          bookmark: true,
          active: false,
        },
        {
          title: "Sessions",
          icon: <LuMonitorSmartphone />,
          path: `/app/sessions`,
          type: "link",
          bookmark: true,
          active: false,
        },


      ],
    },
    {
      menutitle: "Content",
      menucontent: "Users, Courses",
      Items: [
        {
          // title: "Analytics",
          // icon: <PieChart />,
          // path: `${process.env.PUBLIC_URL}/widgets/chart`,
          // active: false,
          // type: "link",


          title: "Build Courses",
          icon: <Book />,
          path: `/app/new-courses`,
          active: false,
          type: "link",
          // children: [
          //   {
          //     path: `${process.env.PUBLIC_URL}/charts/apex`,
          //     type: "link",
          //     title: "Apex",
          //   },
        },
        {
          title: "Course Manager",
          icon: <UploadCloud />,
          path: `/app/course-manager`,
          type: "link",
          bookmark: true,
          active: false,
        },
      ],
    },
  ],
  user: [
    {
      menutitle: "Dashboard",
      menucontent:
        "Home, Courses, Wallet, Achievements",
      Items: [
        {
          title: "Accueil",
          icon: <Home />,
          type: "link",
          path: `/app/home`,
          active: false,
        },
        {
          title: "Cours",
          icon: <Book />,
          badge: "badge badge-light-danger",
          badgetxt: "Nouveau",
          type: "link",
          path: `/app/courses`,
          active: false,
        },
        {
          title: "Favoris",
          icon: <Heart />,
          path: `/app/favourites`,
          type: "link",
          // bookmark: true,
          active: false,
        },
        {
          title: "AI",
          icon: <MessageCircle />,
          path: `/app/ai-chatbot`,
          type: "link",
          active: false,
        },
        {
          title: "Offres",
          icon: <Package />,
          path:`/app/offres`,
          type: "link",
          // bookmark: true,
          active: false,
        },
        
        // {
        //   title: "Wallet",
        //   icon: <CreditCard />,
        //   path: `/app/wallet`,
        //   type: "link",
        //   badge: "badge badge-light-info",
        //   badgetxt: "500",
        //   bookmark: true,
        //   active: false,
        // },
      ],
    },
  ],
};
